import { useContext } from "react";
import { MobXProviderContext } from "mobx-react";
import { ROLE_TYPE_MHP } from "../../../constants/RegisterConstants";
import { RouterAddress } from "../../../constants/RouterAddress";
import ResidentEntryLogPageContent from "../../resident/components/ResidentEntryLogPageContent";

const SharedResidentEntryTrackerPage = () => {
  const { authStore } = useContext(MobXProviderContext);
  const dashboardPathOverride = String(authStore?.getUserRoleType?.() || "").trim().toLowerCase() === ROLE_TYPE_MHP
    ? RouterAddress.MHP_HOME
    : RouterAddress.NURSE_HOME;
  return <ResidentEntryLogPageContent
    expectedRole="caregiver"
    allowSharedStaffAccess
    sharedMode
    dashboardPathOverride={dashboardPathOverride}
    entryType="resident_movement"
    pageTitle="Entry Tracker"
    pageSubtitle="Review and correct resident In and Out entries."
    sectionTitle="Entry Tracker"
    sectionDescription=""
    defaultComposerVisible
    showComposerToggleButton
    compactActionBar
    allowDrafts={false}
    loadEntriesPage={(store, residentId, options) => store.getCaregiverResidentMovementEntriesPage(residentId, options)}
    createEntry={(store, residentId, payload) => store.createCaregiverResidentMovementEntry(residentId, payload)}
    updateEntry={(store, residentId, payload) => store.updateCaregiverResidentMovementEntry(residentId, payload)}
    deleteDraft={(store, residentId, entryLogId) => store.deleteCaregiverResidentMovementEntry(residentId, entryLogId)}
    canEditEntry={() => true}
  />;
};

export default SharedResidentEntryTrackerPage;
